import { combineReducers } from 'redux';
import types from './types';

/* State Shape
{
    isShowingHowSponsorshipsWorksModal: bool,
}
*/

const isShowingHowSponsorshipsWorksModalReducer = (state = false, action) => {
  switch (action.type) {
    case types.SET_IS_SHOWING_HOW_SPONSORSHIPS_WORKS_MODAL:
      return action.payload.isShowingHowSponsorshipsWorksModal;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isShowingHowSponsorshipsWorksModal: isShowingHowSponsorshipsWorksModalReducer,
});

export default reducer;
